import React from "react";
import StepShell from "./StepShell";
import { DoneCheck } from "./Confirmation";
import GmailOffer from "./GmailOffer";

const NEXT = {
  truckstop: "I'll text you the broker's contact.",
  self_book: "I'll text you the broker's contact.",
  chr: "Next, sign up with CH Robinson on Highway. I'll text you the link.",
};

// The end of an onboarding link: nothing was reserved, the agent texts next.
export default function OnboardingDone({ source, token }) {
  return (
    <StepShell question="You're all set" hero={<DoneCheck />}>
      <p className="m-0 font-[Roboto] text-[17px] leading-snug text-slate-700">
        {NEXT[source] || "I'll text you what's next."}
      </p>
      <ul className="m-0 flex list-disc flex-col gap-1.5 pl-5 font-[Roboto] text-[15px] text-slate-600">
        <li>Your payment method is saved.</li>
        <li>We will not charge you without your consent.</li>
      </ul>
      {token && <GmailOffer token={token} />}
    </StepShell>
  );
}
